export type IConstructInvoiceNFELink = (args: {
  cityHallNfs: string | undefined;
  providerDocumentId: string | undefined;
  invoiceKeyCode: string | undefined;
  nrNfeServico: string | undefined;
}) => string | undefined;

export const constructInvoiceNFELink: IConstructInvoiceNFELink = ({
  cityHallNfs,
  providerDocumentId,
  invoiceKeyCode,
  nrNfeServico
}) => {
  if (!cityHallNfs || !providerDocumentId || !invoiceKeyCode || !nrNfeServico) return;

  return `${cityHallNfs}/${providerDocumentId}/${invoiceKeyCode}/${nrNfeServico}`;
};
